/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/camelcase */
import { Box, Checkbox, Grid, makeStyles, Typography } from '@material-ui/core';
import TableItems, { TableCell, TableRow } from 'components/TableItems';
import i18n from 'i18n';
import { getAllClientsRequest } from 'modules/clients/actions';
import {
  BulkClientsFields,
  EnvironmentFields,
  ListBulkClientsProps,
} from 'modules/environments/interfaces';

import React from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import ApplicationState from 'store/interfaces';
import {
  editBulkClientsRequest,
  getBulkClientsRequest,
} from 'modules/environments/actions';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { Formik, Form } from 'formik';
import Button from 'components/Button';
import { modalClose, modalOpen } from 'modules/modal/actions';
import { ModalFields } from 'modules/modal/interfaces';
import palette from 'theme/palette';
import { useTableFilters } from 'hooks/useTableFilters';
import TitleDivider from 'components/TitleDivider';
import DynamicTextField from 'components/DynamicTextField';
import GenericForm from 'skyone-lib/lib/GenericForm';
import { applyI18n } from 'utils/helpers';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';
import { SearchBar } from 'components/SearchBar';
import VerificationCode from 'components/VerificationCode';
import styles from '../styles';
import screenFields from './screenFields';
import schema from '../schema';
import { initialQuery } from '..';

interface Props {
  isLoadingBulkClients: boolean;
  bulkClients: ListBulkClientsProps;
  environment?: EnvironmentFields | null;
  verificationCodeRef: React.MutableRefObject<string[]>;
  setVerificationCode: React.Dispatch<React.SetStateAction<string[]>>;
  editBulkClientsRequest: (props) => void;
  modalClose: () => void;
  modalOpen: (props: ModalFields) => void;
  getBulkClientsRequest: (props) => void;
}

const VirtualizerEdit = ({
  isLoadingBulkClients,
  bulkClients,
  environment,
  verificationCodeRef,
  setVerificationCode,
  editBulkClientsRequest,
  modalClose,
  modalOpen,
  getBulkClientsRequest,
}: Props) => {
  interface ClientInfo {
    client_uuid: string;
    name: string;
  }
  interface VirtualizerInfo {
    virtualizer: string | null;
    connect_port: number | null;
    web_port?: number | null;
  }
  const [selectedAll, setSelectedAll] = React.useState(false);
  const [checks, setChecks] = React.useState<ClientInfo[]>([]);
  const [virtualizer, setVirtualizer] = React.useState<VirtualizerInfo>({
    virtualizer: '',
    connect_port: 50491,
    web_port: 443,
  });
  const [activeAll, setActiveAll] = React.useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const classes = makeStyles(styles)();
  const {
    query,
    searchValue,
    itemOrder,
    handleOrder,
    handleLimitChange,
    handlePageChange,
    handleSearch,
    setSearchValue,
  } = useTableFilters(initialQuery);

  const headers = [
    {
      key: 'nome',
      i18n: 'CLIENT_NAME_KEY',
      order: true,
    },
    {
      key: 'virtualizer',
      i18n: 'BULK_CLIENTS.VIRTUALIZER_KEY',
      order: true,
      centerTitle: false,
    },
    {
      key: 'connect_port',
      i18n: 'BULK_CLIENTS.PORT_ONE_KEY',
      order: true,
      centerTitle: false,
    },
    {
      key: 'web_port',
      i18n: 'BULK_CLIENTS.PORT_TWO_KEY',
      order: true,
      centerTitle: false,
    },
  ];

  const virtualizerEnum = {
    connect: 'ConnectSky',
    connect_direct: 'ConnectSky (Direct Connect)',
    rdp: `Microsoft Remote Desktop (${i18n.t('FILE_KEY')})`,
    rdp_direct: 'Microsoft Remote Desktop (Direct Connect)',
    rdp_app: 'Microsoft Remote Desktop (RemoteApp)',
    tsplus: 'TSPlus (WebBrowser HTML5)',
    tsplus_remote_app: 'TSPlus (RemoteApp)',
    tsplus_all: 'TSPlus (WebBrowser HTML and RemoteApp)',
  };

  const getBulkClients = () => {
    getBulkClientsRequest({
      id,
      query: { ...query },
    });
  };

  React.useEffect(() => {
    getBulkClients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getBulkClientsRequest, query]);

  const handleAllCheck = () => {
    if (!selectedAll) {
      const clientsInfo: ClientInfo[] = bulkClients?.results.map(item => ({
        client_uuid: item?.client_uuid || '',
        name: item?.name || '',
      }));
      setChecks(clientsInfo);
    } else {
      setChecks([]);
    }
    setSelectedAll(!selectedAll);
  };

  const handleCheck = (uuid: string, name: string) => {
    const findCheckId = checks.find(item => item?.client_uuid === uuid);
    if (!findCheckId) {
      setChecks([...checks, { client_uuid: uuid, name }]);
    } else {
      const filteredChecks = checks.filter(item => item?.client_uuid !== uuid);
      setChecks(filteredChecks);
    }
  };
  const clientUuids: string[] = checks.map(client => client?.client_uuid);
  const userConnection = {
    virtualizer: virtualizer.virtualizer,
    connect_port: virtualizer.connect_port,
    web_port: virtualizer.web_port,
  };
  if (
    virtualizer.virtualizer !== 'tsplus_all' &&
    virtualizer.virtualizer !== 'tsplus'
  ) {
    delete userConnection.web_port;
  }

  const handleConfirm = (values: any) => {
    const verificationCodeToSend = verificationCodeRef.current;
    editBulkClientsRequest({
      id,
      dataValues: {
        operator_data: {
          action_reason: values?.action_reason,
          restricted_action_code: verificationCodeToSend.join(''),
        },
        clients_data: [
          {
            cli_uuids: clientUuids,
            user_connection: userConnection,
          },
        ],
      },
    });
    modalClose();
  };

  const handleSubmit = (values: any) => {
    setVerificationCode(Array(6).fill(''));

    editBulkClientsRequest({
      id,
      dataValues: {
        operator_data: {
          action_reason: values?.action_reason,
        },
        clients_data: [
          {
            cli_uuids: clientUuids,
            user_connection: userConnection,
          },
        ],
      },
    });
    modalOpen({
      title: i18n.t('VERIFICATION_CODE_KEY'),
      content: (
        <VerificationCode
          length={6}
          setVerificationCode={setVerificationCode}
          onRetry={() => {
            editBulkClientsRequest({
              id,
              dataValues: {
                operator_data: {
                  action_reason: values?.action_reason,
                },
                clients_data: [
                  {
                    cli_uuids: clientUuids,
                    user_connection: userConnection,
                  },
                ],
              },
            });
          }}
          onConfirm={() => {
            handleConfirm(values);
          }}
        />
      ),
      fullWidth: true,
    });
  };

  const handleSetVirtualizer = values => {
    setVirtualizer(values);
  };

  const dictionaryDefaultPrimaryPortValues = {
    tsplus_all: 50491,
    tsplus: 50491,
    connect: 50491,
    connect_direct: 50491,
    tsplus_remote_app: 50491,
    rdp: 50491,
  };

  const dictionaryDefaultSecondPortValues = {
    tsplus_all: 443,
    tsplus: 443,
  };

  const filteredVirtualizerFields = (values): GenericFormItem[] =>
    applyI18n(
      screenFields.virtualizer.slice(
        0,
        ['tsplus', 'tsplus_all'].includes(values?.user_connection?.virtualizer)
          ? 3
          : 2
      ),
      i18n.language
    );

  const setVirtualizerValues = (key: string, value, setFieldValue): void => {
    if (key === 'user_connection.virtualizer') {
      setFieldValue(key, value);
      return;
    }
    setFieldValue(key, value || null);
  };

  const setDefaultPortValues = (values, value, setFieldValue) => {
    const primaryPortKey = 'user_connection.connect_port';
    const secondPortKey = 'user_connection.web_port';
    const defaultPortValues = {
      [primaryPortKey]: dictionaryDefaultPrimaryPortValues[value],
      [secondPortKey]: dictionaryDefaultSecondPortValues[value],
    };

    if (
      !values.user_connection?.connect_port &&
      defaultPortValues[primaryPortKey]
    ) {
      setFieldValue(primaryPortKey, defaultPortValues[primaryPortKey] || false);
    }
    if (!values.user_connection?.web_port && defaultPortValues[secondPortKey]) {
      setFieldValue(secondPortKey, defaultPortValues[secondPortKey] || false);
    }
  };

  // eslint-disable-next-line consistent-return
  const getWebPortField = (item: BulkClientsFields) => {
    if (item?.user_connection.web_port) {
      return item?.user_connection.web_port;
    }
    if (
      !!item?.user_connection.virtualizer &&
      item?.user_connection.virtualizer !== 'tsplus' &&
      item?.user_connection.virtualizer !== 'tsplus_all'
    ) {
      return '-';
    }
    if (
      !item.user_connection.virtualizer &&
      (environment?.user_connection.virtualizer === 'tsplus' ||
        environment?.user_connection.virtualizer === 'tsplus_all')
    ) {
      return i18n.t('BULK_CLIENTS.ENVIRONMENT_DEFAULT_KEY');
    }
  };

  return (
    <Grid container spacing={2} className={classes.container}>
      <Grid container>
        <Grid container className={classes.valuesForm} spacing={2}>
          <Formik
            initialValues={{ virtualizer: '', connect_port: '', web_port: '' }}
            onSubmit={handleSetVirtualizer}
            enableReinitialize
            validateOnBlur
            validateOnChange
          >
            {({ setFieldValue, errors, values }) => (
              <GenericForm
                overrideClasses={{
                  selectLabel: { fontSize: 12, fontWeight: 500 },
                }}
                fields={values}
                screenFields={filteredVirtualizerFields(values)}
                setFieldValue={(key, value) => {
                  setVirtualizerValues(key, value, setFieldValue);
                  if (key === 'user_connection.virtualizer') {
                    setVirtualizer({
                      ...virtualizer,
                      virtualizer: String(value),
                    });
                  }
                  if (key === 'user_connection.connect_port') {
                    setVirtualizer({
                      ...virtualizer,
                      connect_port: Number(value),
                    });
                  }
                  if (key === 'user_connection.web_port') {
                    setVirtualizer({
                      ...virtualizer,
                      web_port: Number(value),
                    });
                  }
                }}
                changeField={({ key, value }) => {
                  setDefaultPortValues(values, value, setFieldValue);
                  setFieldValue(key, value);
                }}
                errors={errors}
              />
            )}
          </Formik>
        </Grid>
        <Grid
          container
          justify="flex-start"
          className={classes.checkboxActivateAllVirtualizer}
        >
          <Checkbox
            onChange={() => {
              setActiveAll(!activeAll);
              setChecks([]);
            }}
            checked={activeAll}
            id="change-all-clients"
          />
          <Typography className={classes.activeAllText}>
            {i18n.t('BULK_CLIENTS.CONFIG_VIRTUALIZER_IN_ALL_CLIENTS_KEY')}
          </Typography>
        </Grid>
        {!activeAll && (
          <>
            <SearchBar
              id="search-client"
              isLoading={isLoadingBulkClients}
              searchValue={searchValue}
              handleSearch={handleSearch}
              setSearchValue={setSearchValue}
            />
            <TableItems
              header={
                <>
                  <TableCell className={classes.checkboxCell}>
                    <Checkbox
                      onChange={handleAllCheck}
                      id="select-all-clients-environment"
                    />
                  </TableCell>
                  {headers.map(item => (
                    <TableCell
                      key={item?.key}
                      order={item?.order}
                      centerTitle={item?.centerTitle}
                      handleOrder={() =>
                        item?.order ? handleOrder(item?.key) : null
                      }
                      markOderItem={itemOrder === item?.key}
                    >
                      {i18n.t(item?.i18n)}
                    </TableCell>
                  ))}
                </>
              }
              renderItems={(item: BulkClientsFields, index) => (
                <TableRow key={index}>
                  <TableCell className={classes.checkboxCell}>
                    <Checkbox
                      onChange={() =>
                        handleCheck(item?.client_uuid || '', item?.name || '')
                      }
                      checked={
                        !!checks.find(
                          check => check?.client_uuid === item?.client_uuid
                        )
                      }
                    />
                  </TableCell>
                  <TableCell>{item?.name}</TableCell>
                  <TableCell>
                    {item?.user_connection.virtualizer
                      ? virtualizerEnum[item?.user_connection.virtualizer]
                      : i18n.t('BULK_CLIENTS.ENVIRONMENT_DEFAULT_KEY')}
                  </TableCell>
                  <TableCell>
                    {item?.user_connection.connect_port
                      ? item?.user_connection.connect_port
                      : i18n.t('BULK_CLIENTS.ENVIRONMENT_DEFAULT_KEY')}
                  </TableCell>
                  <TableCell>{getWebPortField(item)}</TableCell>
                </TableRow>
              )}
              isLoading={isLoadingBulkClients}
              data={bulkClients}
              overrideRowsCount={10}
              onChangeLimit={handleLimitChange}
              onChangePage={handlePageChange}
              notFoundText={i18n.t('NO_CLIENT_KEY')}
              smallLoading={true}
            />
          </>
        )}
      </Grid>
      <Grid container justify="flex-end" className={classes.buttons}>
        <Button
          id="next-button"
          submitButton
          disabled={
            virtualizer.virtualizer === '' ||
            (checks.length === 0 && !activeAll)
          }
          onClick={() => {
            modalOpen({
              title: i18n.t('BULK_CLIENTS.CONFIRM_CHANGE_VIRTUALIZER_KEY'),
              content: (
                <>
                  <Grid
                    container
                    justify="flex-start"
                    style={{ display: 'block' }}
                  >
                    <Typography style={{ fontSize: 12 }}>
                      {i18n.t('VIRTUALIZER_KEY')}
                      {': '}
                      <Box fontSize={12} fontWeight="bold" display="inline">
                        {virtualizer.virtualizer &&
                          virtualizerEnum[virtualizer.virtualizer]}
                      </Box>
                    </Typography>
                    <Typography style={{ fontSize: 12 }}>
                      {i18n.t('PRIMARY_PORT_KEY')}
                      {': '}
                      <Box fontSize={12} fontWeight="bold" display="inline">
                        {virtualizer?.connect_port}
                      </Box>
                    </Typography>
                    {(virtualizer.virtualizer === 'tsplus' ||
                      virtualizer.virtualizer === 'tsplus') && (
                      <Typography style={{ fontSize: 12 }}>
                        {i18n.t('SECONDARY_PORT_KEY')}
                        {': '}
                        <Box fontSize={12} fontWeight="bold" display="inline">
                          {virtualizer?.web_port}
                        </Box>
                      </Typography>
                    )}
                  </Grid>
                  <Grid container justify="center">
                    <ErrorOutlineIcon
                      style={{ color: palette.deepBlue, width: 30, height: 30 }}
                    />
                  </Grid>
                  {!activeAll ? (
                    <>
                      <Grid container justify="center">
                        <Typography style={{ fontSize: 12, marginBottom: 12 }}>
                          {i18n.t(
                            'BULK_CLIENTS.CONFIRM_CHANGE_VIRTUALIZER_IN_CLIENTS_KEY'
                          )}
                        </Typography>
                      </Grid>
                      <TableItems
                        header={
                          <>
                            <TableCell className={classes.tableRow}>
                              {i18n.t('CLIENT_NAME_KEY')}
                            </TableCell>
                          </>
                        }
                        renderItems={(item: BulkClientsFields, index) => (
                          <TableRow key={index}>
                            <TableCell>{item?.name}</TableCell>
                          </TableRow>
                        )}
                        isLoading={isLoadingBulkClients}
                        data={{
                          count: 0,
                          next: '',
                          previous: '',
                          results: checks,
                        }}
                        onChangeLimit={handleLimitChange}
                        onChangePage={handlePageChange}
                        notFoundText={i18n.t('NO_CLIENT_KEY')}
                        notFooter
                        smallLoading={true}
                      />
                    </>
                  ) : (
                    <Grid container justify="center">
                      <Typography style={{ fontSize: 12 }}>
                        {i18n.t(
                          'BULK_CLIENTS.CONFIRM_CHANGE_VIRTUALIZER_IN_ALL_CLIENTS_KEY'
                        )}
                      </Typography>
                    </Grid>
                  )}
                  <TitleDivider
                    overrideClasses={{
                      title: { margin: '12px 4px 8px 4px', fontSize: 12 },
                    }}
                  >
                    {i18n.t('BULK_CLIENTS.SET_CONNECTION_TYPE_TO_CONFIRM_KEY')}
                  </TitleDivider>
                  <Formik
                    initialValues={{ action_reason: '' }}
                    enableReinitialize
                    validationSchema={schema}
                    validateOnChange
                    validateOnBlur
                    onSubmit={handleSubmit}
                  >
                    {({ setFieldValue, errors, values, submitForm }) => {
                      return (
                        <React.Fragment>
                          <Form>
                            <Grid container>
                              <Grid
                                container
                                spacing={2}
                                className={classes.fields}
                              >
                                <DynamicTextField
                                  {...screenFields.confirmation[0]}
                                  setFieldValue={setFieldValue}
                                  value={values?.action_reason}
                                  errors={errors}
                                />
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              justify="flex-end"
                              style={{ marginTop: 12 }}
                            >
                              <Button
                                submitButton
                                id="confirm-button"
                                onClick={submitForm}
                                isLoading={isLoadingBulkClients}
                              >
                                {i18n.t('CONTINUE_KEY')}
                              </Button>
                              <Button
                                id="cancel-button"
                                variant="outlined"
                                onClick={modalClose}
                              >
                                {i18n.t('CANCEL_KEY')}
                              </Button>
                            </Grid>
                          </Form>
                        </React.Fragment>
                      );
                    }}
                  </Formik>
                </>
              ),
            });
          }}
        >
          {i18n.t('NEXT_KEY')}
        </Button>
        <Button id="cancel-button" variant="outlined" onClick={modalClose}>
          {i18n.t('CLOSE_KEY')}
        </Button>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = ({
  environments: { environmentSelected, bulkClients, isLoadingBulkClients },
}: ApplicationState) => ({
  environmentSelected,
  bulkClients,
  isLoadingBulkClients,
});

export default connect(mapStateToProps, {
  getAllClientsRequest,
  modalClose,
  editBulkClientsRequest,
  modalOpen,
  getBulkClientsRequest,
})(VirtualizerEdit);
